import { type ComponentType, type FC, Fragment } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { Stack } from '@myphx-engineering/phx-design-system';

import {
    useFillPathway,
    useFillPrescription,
} from '../../../contexts/fill/use-fill-prescription';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';
import { SavingsCardTeaser } from '../../common/savings-card';

import { CoverageNotice } from './common/CoverageNotice';
import { InsuranceAttestation } from './insurance/InsuranceAttestation';
import { SelfPayAttestation } from './self-pay/SelfPayAttestation';

export const AttestationScreen: FC = () => {
    const { drxId } = useFillPrescription();
    const { pathway } = useFillPathway();
    const [searchParams] = useSearchParams();

    let Attestation: ComponentType = Fragment;

    switch (pathway) {
        case 'self-pay':
            Attestation = SelfPayAttestation;
            break;
        case 'insurance':
            Attestation = InsuranceAttestation;
            break;
        case 'fallback':
            return (
                <Navigate
                    replace
                    to={{
                        pathname: getAbsoluteRoute(
                            'fill.drxId.coverageSelect',
                            {
                                drxId,
                            }
                        ),
                        search: `?${searchParams.toString()}`,
                    }}
                />
            );
    }

    return (
        <Stack gap="lg" data-testid="attestation-page-root">
            <CoverageNotice />
            <SavingsCardTeaser />
            <Attestation />
        </Stack>
    );
};
